import React, { useState, useRef, useEffect } from "react";
import Button from "@mui/material/Button";
import { LoginValue } from "../../Actions/LoginPageAction";
import { useDispatch, useSelector } from "react-redux";
import "./MFALogin.css";
import checkImg from "../../assets/images/check_circle.svg";
import BackupLogin from "./BackupLogin";
import { setProgress } from "../../Actions/progressAction";
import { resetRememberDeviceState } from "../../reducers/RememberDeviceReducer";
import PropTypes from "prop-types";
import {
  verifyEmailCode,
  resendEmailCode,
  rememberDeviceAction,
  resetEmailDialogState,
} from "../../Actions/EmailDialogActions";

const EmailDialog = ({ onCancel }) => {
  const [code, setCode] = useState("");
  const [message, setMessage] = useState("");
  const [successDialogOpen, setSuccessDialogOpen] = useState(false);
  const [showBackupLogin, setShowBackupLogin] = useState(false);
  const dispatch = useDispatch();
  const verifyButtonRef = useRef(null);
  const nextButtonRef = useRef(null);

  const rememberDeviceCheck = useSelector(
    (state) => state.rememberDevice.rememberDeviceCheck
  );
  const { isVerified, errorMessage, resendStatus } = useSelector(
    (state) => state.emailDialog
  );

  useEffect(() => {
    dispatch(setProgress(successDialogOpen ? 100 : 60));
  }, [dispatch, successDialogOpen]);

  useEffect(() => {
    if (isVerified) {
      setMessage("Verification successful!");
      setTimeout(() => {
        nextButtonRef.current?.focus();
      }, 100);
    }
  }, [isVerified]);

  const handleResendClick = () => {
    dispatch(resendEmailCode());
    setMessage("");
  };

  const handleCodeVerification = () => {
    if (!code || code.length !== 6) {
      return dispatch({
        type: "EMAIL_VERIFY_CODE_ERROR",
        payload: !code
          ? "Please enter the verification code."
          : "Please enter a 6-digit code.",
      });
    }

    dispatch(verifyEmailCode(code));
  };
  const handleNext = async () => {
    if (rememberDeviceCheck) {
      await dispatch(rememberDeviceAction());
    }

    dispatch(setProgress(100));
    setSuccessDialogOpen(true);
  };

  const handleBackupCodeClick = () => {
    setShowBackupLogin(true);
  };

  const handleCancelBackup = () => {
    setShowBackupLogin(false);
    dispatch(resetRememberDeviceState());
  };

  const handleDone = () => {
    localStorage.setItem("isMFACompleted", "true");
    localStorage.setItem("isAuthenticated", "true");
    localStorage.setItem("lastPath", "/dashboard");

    dispatch(LoginValue(true));
    dispatch(resetRememberDeviceState());
    dispatch(resetEmailDialogState());
  };

  const renderResendMessage = () => {
    if (resendStatus === "success") {
      return (
        <div
          role="alert"
          aria-live="assertive"
          style={{ color: "green", marginTop: "20px" }}
        >
          Code has been resent.
        </div>
      );
    }
    if (resendStatus === "error") {
      return (
        <div
          role="alert"
          aria-live="assertive"
          style={{ color: "red", marginTop: "20px" }}
        >
          Failed to resend the code.
        </div>
      );
    }
    return null;
  };
  const content = showBackupLogin ? (
    <BackupLogin onCancel={handleCancelBackup} />
  ) : (
    <div className="succes_modal">
      <img src={checkImg} alt="" />
      <h2>Success</h2>
      <p id="sucessVerify">Your verification is successfully completed.</p>

      <div className="mfa-save">
        <Button onClick={handleDone} className="done-btn" id="MFA_doneBtn" disableRipple>
          Done
        </Button>
      </div>
    </div>
  );
  useEffect(() =>{
    setTimeout(() => {
      const verifyInput = document.getElementById("verifyInputCode");
      verifyInput?.focus();
    }, 1500);
  },[])
useEffect(() => {
  if (successDialogOpen) {
    setTimeout(() => {
      const doneBtn = document.getElementById("MFA_doneBtn");
      doneBtn?.focus();
    }, 200);
  }
}, [successDialogOpen]);
  return (
    <>
      {!successDialogOpen && !showBackupLogin ? (
        <>
          <div className="dialog-content emailDailog_wrapper" role="group" aria-labelledby="verfycode">
            <p id="verfycode">
              Please enter the verification code that was sent to your email.
            </p>
            <div className="authenticator-input">
              <div className="label-text">Verification Code  <span style={{ color: 'red' }} aria-hidden>*</span></div>
              <div className="align-buttons">
                <input
                  type="text"
                  className="text-box"
                  value={code}
                  placeholder="Enter Verification Code"
                  id="verifyInputCode"
                  maxLength="6"
                  onChange={(e) => {
                    setCode(e.target.value);
                    setMessage("");
                    dispatch(resetEmailDialogState());
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      verifyButtonRef.current.focus();
                      handleCodeVerification();
                    }
                  }}
                  required
                />
                <div className="send-code-button">
                  <Button
                    color="primary"
                    ref={verifyButtonRef}
                    className="btn-text"
                    onClick={() => {
                      setMessage("");
                      handleCodeVerification();
                    }}
                    disableRipple
                  >
                    Verify
                  </Button>
                  <Button
                    color="primary"
                    className="btn-text"
                    onClick={() => {
                      handleResendClick();
                    }}
                    disableRipple
                  >
                    Resend
                  </Button>
                </div>
              </div>
            </div>
            <Button onClick={handleBackupCodeClick} className="loginViacode" disableRipple>
              Login via backup code
            </Button>
            {message && (
              <div role="alert"  aria-live="assertive"  style={{ color: "green", marginTop: "20px" }}>{message}</div>
            )}
            {errorMessage && (
              <div role="alert"  aria-live="assertive"  style={{ color: "red", marginTop: "20px" }}>
                {errorMessage}
              </div>
            )}
            {renderResendMessage()}
          </div>
          <div className="mfa-save">
            <Button
              color="primary"
              className={`disabled-button ${!isVerified ? "disbleBtn" : ""}`}
              disabled={!isVerified}
              onClick={handleNext}
               ref={nextButtonRef}
               disableRipple
            >
              Next
            </Button>
          </div>
        </>
      ) : (
        content
      )}
    </>
  );
};

EmailDialog.propTypes = {
  onCancel: PropTypes.func.isRequired,
};

export default EmailDialog;
